import {
    DeslogarUsuarioHelpDeskService,
    LogarUsuarioHelpDeskService,
} from "../../../Services/HelpDesk/User/UserHelpDeskServices";
import { Controller } from "../../Controller";

export async function LogarUsuarioHelpDeskController() {
    return Controller(LogarUsuarioHelpDeskService());
}

export async function DeslogarUsuarioHelpDeskController() {
    return Controller(DeslogarUsuarioHelpDeskService());
}
